<template>
  <div class="upload">

    <kendo-upload ref="upload"
                  name="files"
                  :multiple="true"
                  :show-file-list="false"
                  :async-auto-upload="false"
                  :localization-select='buttonText'
                  @select="onSelectFile"
                  :validation-allowed-extensions='[".jpg", ".jpeg", ".png", ".gif"]'>
    </kendo-upload>
  </div>
</template>

<script>
export default {
  name: 'SendFileUpload',
  props: {
    file: {
      default: []
    },
    buttonText: {
      type: String,
      default: "파일 선택",
    },
  },
  mounted: function () {

  },
  data: function () {
    return {
      vvsrc: ''
    }
  },
  methods: {
    onSelectFile: function (e) {
      const vm = this
      const files = e.files
      // 확장자 체크
      let fileSpliceIndex = -1
      const file = files[0]
      const raw = file.rawFile
      const reader = new FileReader()
      if (raw) {
        reader.onloadend = function (event) {
          // 파일 시그니처 확인
          if (event.target.readyState === FileReader.DONE) {
            const arrayBuffer = event.target.result
            const byteArray = new Uint8Array(arrayBuffer)
            const extensions = {
              jpg: [255, 216],
              jpeg: [255, 216],
              png: [137, 80, 78, 71, 13, 10, 26, 10],
              gif: [71, 73, 70, 87, 8, 0, 0, 0],
              // exe: [77, 90]
            }

            function checkExtension(byteArray, extensionSignature) {
              return extensionSignature.every((value, index) => value === byteArray[index])
            }

            let fileExtension = null
            for (const extension in extensions) {
              if (checkExtension(byteArray, extensions[extension])) {
                fileExtension = extension
                break
              }
            }
            if (fileExtension !== null) {
              fileSpliceIndex = files.indexOf(file)
              if (fileSpliceIndex > -1) {
                vm.$emit('child', files)
              }
            } else {
              kendo.alert('올바른 파일 확장자가 아닙니다.')
              e.preventDefault()
            }
          }
        }

        reader.readAsArrayBuffer(raw)
      }
    },
  }
}
</script>
<style scoped>
.upload span.k-file-extension {
  font-size: 10px !important;
}
</style>
